import Vuex from 'vuex';
import Vue from 'vue';
import app from './modules/app';
import nav from './modules/nav';
import giftVouchers from './modules/gift-vouchers';
import supplierPayments from './modules/payments/supplierPayments';
import clientPayments from './modules/payments/clientPayments';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  modules: {
    app,
    nav,
    giftVouchers,
    supplierPayments,
    clientPayments,
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js